/**
 * .modal-content-loader
 * Whenever we close #remote Bootttrap modal, we need to refresh the loader
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

$(document).ready(function(){

    // Get the value of loader
    var loader = $('.modal-content-loader').html();

    $('body').on('hidden.bs.modal', '.modal#remote', function () {
        // Remove the inline data from the modal
        $(this).removeData('bs.modal');
        // Replace data with a loader
        $(this).find('.modal-content').html(loader);
    });
});
